/**
 * Table naming utilities for consistent module-prefixed table names
 */

/**
 * Create a table name with module prefix
 * @param module - Module name (e.g., 'tea', 'clientbase', 'testaburger')
 * @param entity - Entity name (e.g., 'users', 'leads', 'burgers', 'user_roles_lnk')
 * @returns Prefixed table name (e.g., 'tea_users', 'clientbase_leads', 'identity_user_roles_lnk')
 */
export const createTableName = (module: string, entity: string): string => {
  // Validate inputs
  if (!module || !entity) {
    throw new Error('Module and entity names are required for table naming');
  }

  // Ensure lowercase and valid characters (preserve underscores in entity names)
  const cleanModule = module.toLowerCase().replace(/[^a-z0-9]/g, '');
  const cleanEntity = entity.toLowerCase().replace(/[^a-z0-9_]/g, '');

  if (!cleanModule || !cleanEntity) {
    throw new Error('Module and entity names must contain valid characters');
  }

  return `${cleanModule}_${cleanEntity}`;
};

/**
 * Validate table name format
 * @param tableName - Table name to validate
 * @returns True if valid format (module_entity, where entity can contain underscores)
 */
export const isValidTableName = (tableName: string): boolean => {
  const pattern = /^[a-z][a-z0-9]*_[a-z][a-z0-9_]*$/;
  return pattern.test(tableName);
};
